import styled from "styled-components";

export const CardContainer = styled.div`
  width: 100%;
  height: 50px;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  display: flex;

  .solicitacaocaseNumber {
    color: ${({ tema }) => tema};
    font-weight: bold;
    text-decoration: underline;
    span {
      cursor: pointer;
    }
  }

  .solicitacaoclassificacao,
  .solicitacaoagendamento {
    background-color: #f6f6f6;
  }

  .solicitacaocaseNumber,
  .solicitacaoclassificacao {
    width: 12%;
  }

  .solicitacaoagendamento {
    width: 14%;
  }

  .solicitacaodataAbertura {
    width: 10%;
  }

  .solicitacaoativo {
    width: 32%;
  }

  .solicitacaoclassificacao,
  .solicitacaodataAbertura,
  .solicitacaoagendamento,
  .solicitacaoativo {
    color: #848484;
    font-weight: bold;
  }

  .solicitacaostatus {
    width: 20%;
    border-bottom: none;
    display: flex;
    justify-content: center;
  }

  .containerItem {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #848484;
    padding: 0 16px;
  }
  .solicitacaostatus {
    border-bottom: none;
    button {
      border: none;
      width: 120px;
      padding: 10px 8px;
      border-radius: 4px;
      text-transform: uppercase;
      color: ${({ color }) => color.colorText};
      font-weight: bold;
      cursor: pointer;
      transition: 0.3s;
      background-color: ${({ color }) => color.bg};
      font-size: 12px;
      &:hover {
        box-shadow: 0px 0px 8px ${({ color }) => color.bg};
      }
    }
  }

  span {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    height: auto;
    display: grid;
    grid-template-columns: 50% 50%;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .containerItem {
      min-height: 30px;
      border-bottom: none;
      width: 150px;
      padding: 0;
      justify-content: center;
    }
    border-bottom: 2px solid #848484;
    border-radius: 0;
    padding: 8px 0;
  }
`;
